// src/components/listing/ListingDetailSkeleton.js
// Squelette de chargement pour la page détail d'annonce - NE PAS MODIFIER

import React from 'react';
import { useTheme } from '../../hooks/useTheme';

const ListingDetailSkeleton = () => {
  const { theme } = useTheme();

  const shimmerBase = theme.mode === 'light' ? '#EDEFEC' : '#1A2436';
  const shimmerHighlight = theme.mode === 'light' ? '#F7F9F7' : '#243247';

  const styles = {
    container: { display: 'flex', flexDirection: 'column', backgroundColor: theme.bg, minHeight: '100vh' },
    block: (width, height, radius = '8px', extra = {}) => ({
      width, height, borderRadius: radius,
      background: `linear-gradient(90deg, ${shimmerBase} 25%, ${shimmerHighlight} 50%, ${shimmerBase} 75%)`,
      backgroundSize: '200% 100%',
      animation: 'fynhoShimmer 1.6s ease-in-out infinite',
      ...extra,
    }),
    imageArea: { width: '100%', height: '300px' },
    content: { padding: '20px 16px', display: 'flex', flexDirection: 'column', gap: '18px' },
    detailsRow: { display: 'flex', gap: '16px' },
    amenityRow: { display: 'flex', gap: '8px', flexWrap: 'wrap' },
  };

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes fynhoShimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>

      {/* Photo principale */}
      <div style={styles.block('100%', '300px', '0px', styles.imageArea)} />

      <div style={styles.content}>
        {/* Titre */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <div style={styles.block('85%', '22px')} />
          <div style={styles.block('50%', '14px')} />
        </div>

        {/* Prix */}
        <div style={styles.block('120px', '28px', '8px')} />

        {/* Détails (chambres/sdb/superficie) */}
        <div style={{ ...styles.block('100%', '80px', '12px') }} />

        {/* Description */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <div style={styles.block('140px', '18px')} />
          <div style={styles.block('100%', '14px')} />
          <div style={styles.block('95%', '14px')} />
          <div style={styles.block('70%', '14px')} />
        </div>

        {/* Équipements */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <div style={styles.block('120px', '18px')} />
          <div style={styles.amenityRow}>
            <div style={styles.block('80px', '30px', '8px')} />
            <div style={styles.block('100px', '30px', '8px')} />
            <div style={styles.block('70px', '30px', '8px')} />
          </div>
        </div>

        {/* Avis */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <div style={styles.block('100px', '18px')} />
          <div style={styles.block('100%', '60px', '12px')} />
        </div>
      </div>
    </div>
  );
};

export default ListingDetailSkeleton;